import "antd/dist/reset.css";
import { Collapse, Divider, Descriptions } from "antd";
import React from "react";
import utils from "utils";
import "./SOSSummaryChild.scss";

const { Panel } = Collapse;

let componentsArray = [];

const iterateSummary = (sumVal, completion_date, iteration) => {
  if (sumVal.field_type) {
    let content = "";
    if (sumVal.field_type === "check_box") {
      content = sumVal.values
        .filter((item) => item.is_selected)
        .map((item) => item.label)
        .join(" | ");
    } else {
      content = ansVal.comments;
    }
    if (content != "") {
      componentsArray.push(
        <Descriptions
          key={`${sumVal.title}_${completion_date}_${iteration}`}
          size="middle"
          bordered
          labelStyle={{ width: "50%" }}
        >
          <Descriptions.Item label={sumVal.title}><ul>
                    {(content?.split("|").map(i=>{
                      return(
                       <li>{i}</li>)
                    }))}
                    </ul></Descriptions.Item>
        </Descriptions>
      );
    }

    return true;
  } else {
    let answers = Object.entries(sumVal.values).map(([ansKey, ansVal]) => {
      let content = "";
      if (ansVal.field_type === "check_box") {
        content = ansVal.values
          .filter((item) => item.is_selected)
          .map((item) => item.label)
          .join(" | ");
      } else {
        content = ansVal.comments;
      }

      return {
        key: ansKey,
        label: ansVal.label,
        content: content,
      };
    });

    const isValid = answers.some((ans) => ans.content != "");

    if (isValid) {
      componentsArray.push(
        <div
          key={`sub-header_${completion_date}_${iteration}`}
          className="sub-header"
        >
          {sumVal.title}
        </div>
      );
      componentsArray.push(
        <div key={`sub-header-desc_${completion_date}_${iteration}`}>
          <Descriptions
            bordered
            layout="horizontal"
            column={1}
            labelStyle={{ width: "50%" }}
          >
            {answers.map((ans) => {
              return (
                ans.content && (
                  <Descriptions.Item key={ans.key} label={ans.label}>
                    <ul>
                    {(ans?.content?.split("|").map(i=>{
                      return(
                       <li>{i}</li>)
                    }))}
                    </ul>
                  </Descriptions.Item>
                )
              );
            })}
          </Descriptions>
        </div>
      );
      componentsArray.push(
        <Divider key={`sub-header-end_${completion_date}_${iteration}`} />
      );
    }
    return true;
  }
};

const transformSummaries = (summaries) => {
  return Object.entries(summaries).map(([sumKey, sumVal], index) => {
    if (typeof sumVal === "object") {
      let tmp = iterateSummary(sumVal, summaries.completion_date, index);
      return tmp;
    }
    return true;
  });
};

const SOSSummaryChild = (props) => {
  componentsArray = [];
  componentsArray.push(
    // <div key={props.data.completion_date} className="main-header">
    //   {props.data.title}
    // </div>
  );
  const summaries = transformSummaries(props.data);

  return (
    <>
      {props.data?.completion_date && summaries.length > 0 ? (
        <Collapse
          style={{ overflowY: "auto" }}
          bordered={false}
          expandIconPosition="start"
          ghost={true}
          className="mhe-list-container"
        >
          <Panel
            header={
              <div>
                {utils.FormatDate(props?.data?.completion_date, "DATE_14")},{" "}
                {utils.FormatDate(props?.data?.completion_date, "TIME_1")}
              </div>
            }
            extra={utils.FirstNameLastName(utils.salutationPrefixName(props?.data?.doctor_salutation,utils.getDisplayName(props?.data?.consultation_doctor, props?.data?.doctor_last_name)), "250px")}
            key="1"
          >
            {componentsArray.map((item) => item)}
          </Panel>
        </Collapse>
      ) : null}
    </>
  );
};

export default SOSSummaryChild;
